import { mapGetters } from 'vuex'
import { createFeatureDecisions } from '@/services/features/featureDecisions'
import clientGroupOverviewFeatureFactory from '@/services/features/clientGroupOverviewFeatureFactory'

export default {
  computed: {
    ...mapGetters({
      featureToggles: 'features/featureToggles',
      isClientGroupOverviewEnabled: 'auth/isClientGroupOverviewEnabled',
    }),
    featureDecisions() {
      return createFeatureDecisions(this.featureToggles)
    },
    clientGroupOverviewFeatureToggles() {
      return clientGroupOverviewFeatureFactory(
        this.featureDecisions,
        this.isClientGroupOverviewEnabled
      )
    },
  },
}
